import { Action } from '@ngrx/store';

export const CHECK_GLOBAL_LOCK_SUCCESS = '[Customer] Check Global Lock Success';

export class CheckGlobalLockSuccessAction implements Action {
  readonly type = CHECK_GLOBAL_LOCK_SUCCESS;
  constructor(public payload: {
    active: boolean;
  }) { }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/CheckGlobalLockSuccessAction.ts